import React, {useEffect, useState,useMemo} from 'react';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system';
import Button from '@mui/material/Button'
import { Delete, Edit, QuestionAnswer } from '@mui/icons-material';
import getReq from '../interface/getRequestinterface';
import { deleteRequest, getRequest } from '../request';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import { useMediaQuery } from "react-responsive"; 
import jwtDecode from 'jwt-decode';
import { Tooltip, IconButton } from '@mui/material';
import DeleteModal from '../components/deleteModal.tsx';
import Loading from './loading';

const style={
    formTitle:{
      fontWeight:'bold !important'
    },
    formDescription:{
      color:'#9b9b9b'
    },
    formContainer:{
      padding: '1rem !important',
      border: '3px solid #748DA6',
      borderRadius: '10px',
      backgroundColor: '#f1f7ff59',
      height:'auto'
    },
    gridBox:{
      display:'grid',
      gridTemplateColumns:'40% 40%',
      columnGap:'5%',
      rowGap:'3%',
      justifyContent:'space-around',
      marginTop:'2rem'
    },
    mobileGridBox:{
      display:'grid',
      gridTemplateColumns:'90%',
      // columnGap:'5%',
      rowGap:'3%',
      justifyContent:'center',
      marginTop:'2rem'
    },
    modalStyle :{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'30rem'
    },
    modalMobileStyle:{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      p: 4,
      backgroundColor:'#fff',
      display:'flex',
      flexDirection:'column',
      borderRadius:'3px',
      width:'15rem'
    },
    txtField:{
      width:'100%', 
    },
    headerContainer:{
      display:'flex',
      width:'100%',
      justifyContent:'space-between'
    },
    stateHandler:{
      display:'flex',
      justifyContent:'center'
    },
    stateType:{fontWeight:'bold'},
    title:{
      display:'flex',
      justifyContent:'space-between',
      width:'65rem',
    }
  }
  
  interface QuestionString{
    questionString:string;
    questionId:number;
  }
  interface QuestionList{
    pollformName:string;
    pollformId:number;
    filled:boolean;
    questions:QuestionString[];
  }
  var token:string|null = '';

function ClientAnswerPoll() {
  const [questionList, setQuestionList] = useState<Array<QuestionList>>([]);
  const [decodedToken, setDecodedToken] = useState<any>({});
  const [deletedPoll, setDeletedPoll] = useState<number>(-1);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const [isSuccessful, setIsSuccessful] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
    token = localStorage.getItem("token");
    const cacheRtl = useMemo(() => {
      return createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin]
      });
    }, []);
    const fetchQuestions = async()=>{
      const {data,error}:getReq = await getRequest(`${process.env.REACT_APP_BASE_URL}/Poll/GetAllForms`) as getReq;
      if(!error){
        console.log(data)
        setQuestionList(data.map(x=>({
          pollformName:x.pollformName,
          pollformId:x.pollformId,
          filled:x.filled,
          questions:x.questions.map(q=>({questionString:q.questionString,questionId:q.questionId}))
        })));
        setTimeout(() => {
          setIsLoading(true);
        }, 1500);
      }else{
        toast.error(error);
      }
    }
    const isDesktop = useMediaQuery({
      query: "(min-width: 1224px)"
    });
    
    const isTablet = useMediaQuery({
      query: "(max-width: 768px)"
    });
    
    const isMobile = useMediaQuery({
      query: "(max-width: 400px)"
    });
    useEffect(() => {
      fetchQuestions();
    }, []);
    let decode:any = {};
    useEffect(() => {   
        if (token) {
          decode = jwtDecode(token);
          setDecodedToken(decode);
        }
    }, [token]);

    const handleRemoveQuestion=async(pollformId)=>{
      setDeletedPoll(pollformId);
      setOpenDeleteModal(true);
    }
    const routeToEditPage= (pollformId)=>{
      navigate(`/expertCheckPoll/${pollformId}`);
    }
  return (
    <CacheProvider value={cacheRtl}>
      
      <div className='background'>
      <Box sx={isDesktop? style.gridBox:style.mobileGridBox}>
          <Typography variant="h5" sx={style.formTitle}>لیست فرم های نظرسنجی:</Typography>
          <div></div>
      </Box>
      {isLoading?
          <Box sx={isDesktop? style.gridBox:style.mobileGridBox}>
              {
                  questionList.map((question,index)=>
                      <Box key={index} sx={style.formContainer}>
                        <Box sx={{display:'flex'}}>
                          <Typography variant="body1">{question.pollformName}</Typography>
                        {
                          (decodedToken.role === 'Admin'|| decodedToken.role === 'Expert')?
                          <div>
                            <Tooltip title="حذف نظرسنجی">
                              <IconButton 
                                sx={{padding:'0px',marginLeft:'1rem'}}
                                color='secondary'
                                onClick={()=>handleRemoveQuestion(question.pollformId)}
                              >
                                <Delete sx={{color:'#fb4c52'}}/>
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="ویرایش نظرسنجی">
                              <IconButton 
                                sx={{padding:'0px',marginLeft:'1rem'}}
                                color='secondary'
                                onClick={()=>routeToEditPage(question.pollformId)}
                              >
                                <Edit sx={{color:'#4caf50'}}/>
                              </IconButton>
                            </Tooltip>
                          </div>:null
                        }
                        </Box>
                          {
                          //   question.filled?
                            
                          (decodedToken.role === 'Admin'|| decodedToken.role === 'Expert')?
                          <Link to={`/showWhoAnswersPoll/${questionList[index].pollformId}`} 
                          state={{pollformId:questionList[index].pollformId,questions: questionList[index].questions}} 
                          style={{textDecoration:'none'}}
                          >
                          <Box sx={{width:'100%',display:'flex',justifyContent:'end'}}>
                              <Button variant="contained" sx={{backgroundColor:'#0E5E6F'}}>
                              نمایش جزئیات<QuestionAnswer/>
                              </Button>
                          </Box>
                        </Link>:
                          question.filled?
                          <Box sx={{width:'100%',display:'flex',justifyContent:'end', }}>
                            <Typography variant="body1" sx={{fontWeight:'bold'}}>پاسخ داده شده</Typography>
                          </Box>:
                          <Link to={`/clientPoll/${question.pollformId}`} 
                          state={{pollformId:questionList[index].pollformId,questions: questionList[index].questions}} 
                          style={{textDecoration:'none'}}
                          >
                          <Box sx={{width:'100%',display:'flex',justifyContent:'end'}}>
                              <Button variant="contained" color="primary" >
                              پاسخگویی<QuestionAnswer/>
                              </Button>
                          </Box>
                        </Link>
                          }
                      </Box>    
                  )
              }
          </Box>
      :
        <div style={{width:'100vw',height:'calc( 100vh - 64px)',display:'flex',justifyContent:'center',alignItems:'center'}}>
          <Loading type="cylon" color="#000"/>
        </div>
      }
      </div>
        
        <DeleteModal
        deleteURL={`${process.env.REACT_APP_BASE_URL}/Poll/RemovePollForm/${deletedPoll}`}
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        destination=''
        parameterName='نظرسنجی'
        setIsSuccessful={setIsSuccessful}
        />
    </CacheProvider>
  )
}

export default ClientAnswerPoll
